import type {ReactElement} from 'react';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {getTranscriptItemsInCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {setSelectedTimelineItem} from '../../timeline-reducer';
import {TimelineTrack} from '../timeline-track/timeline-track';
import {SubtitleTimelineItem} from '../subtitle-timeline-item/subtitle-timeline-item';
import {SUBTITLE_TRACK_HEIGHT, TimelineItemType} from '../../timeline.types';
export function TranscriptTimelineTrack(): ReactElement | null {
  const dispatch = useAppDispatch();
  const transcriptItems = useAppSelector(getTranscriptItemsInCurrentPage);

  const handleSubtitleClick = (subtitleId: string, transcriptId: string): void => {
    void window.posterEditor?.whiteboard?.pause();

    const transcript = window.posterEditor?.whiteboard?.getItemForId(transcriptId);
    if (transcript) {
      transcript.page.clearSelection();
      transcript.page.activeSelection.selectFabricObjects([transcript.fabricObject]);
    }

    dispatch(setSelectedTimelineItem({type: TimelineItemType.SUBTITLE, id: subtitleId}));
  };

  const transcriptsWithSubtitles = transcriptItems.filter((item) => Object.keys(item.subtitlesHashmap).length > 0);

  if (transcriptsWithSubtitles.length === 0) {
    return null;
  }

  return (
    <TimelineTrack totalRows={transcriptsWithSubtitles.length} trackHeight={SUBTITLE_TRACK_HEIGHT}>
      {transcriptsWithSubtitles.map((transcriptItem, transcriptRowIndex) =>
        Object.entries(transcriptItem.subtitlesHashmap).map(([subtitleId, subtitle]) => (
          <SubtitleTimelineItem
            key={subtitleId}
            id={subtitleId}
            transcriptId={transcriptItem.uid}
            startTime={subtitle.startTime}
            endTime={subtitle.endTime}
            subRow={transcriptRowIndex}
            onClick={handleSubtitleClick}
          />
        ))
      )}
    </TimelineTrack>
  );
}
